import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';

const cardData = [
  {
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744391537/image_awqhfq.png",
    date: "March 03, 2025",
    title: "How High Presicision Farming is changing agriculture",
    description: "Smart  farming uses technology such as mobile application to improving production ",
    link: 'Innovation1',
  },
  {
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744391537/image-1_vb8vem.png",
    date: "March 03, 2025",
    title: "How High Presicision Farming is changing agriculture",
    description: "Smart  farming uses technology such as mobile application to improving production ",
    link: 'Innovation2',
  },
  {
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744391537/image-2_uxvevv.png",
    date: "March 03, 2025",
    title: "How High Presicision Farming is changing agriculture",
    description: "Smart  farming uses technology such as mobile application to improving production ",
    link: 'Innovation3',
  },
  {
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744391537/image-3_gtepex.png",
    date: "March 03, 2025",
    title: "How High Presicision Farming is changing agriculture",
    description: "Smart  farming uses technology such as mobile application to improving production ",
    link: 'Innovation4',
  },
  {
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744391537/image-4_zu3iwp.png",
    date: "March 03, 2025",
    title: "How High Presicision Farming is changing agriculture",
    description: "Smart  farming uses technology such as mobile application to improving production ",
    link: 'Innovation5',
  },
  {
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744391537/image-5_cw3rlj.png",
    date: "March 03, 2025",
    title: "How High Presicision Farming is changing agriculture",
    description: "Smart  farming uses technology such as mobile application to improving production ",
    link: 'Innovation5',
  },
];

const CardSection = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timeout);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-12 h-12 border-4 border-yellow-400 border-dashed rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <section className="relative bg-white md:px-20 px-4 md:pb-10 md:pt-6 pb-3 mt-5">
      <div className="md:px-4">
        <div className='flex justify-between'>
          <h1 className="text-[14px] md:text-[36px] font-bold mt-3 text-[#FDBD26]">Insights & Innovations</h1>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744287925/Expand_down_hlf9gz.png"
            alt="icon"
            className="w-6 h-6 md:w-8 md:h-8"
          />
        </div>
        <h1 className="text-[8px] md:text-[32px] font-normal md:mb-8 md:mt-2 mb-4 text-black" style={{ lineHeight: "1.20" }}>
          Smart farming refers to the use of advanced technology and data-driven solutions to optimize agricultural practices. It aims to improve the efficiency, productivity, and sustainability of farming by integrating modern technologies like sensors, data analytics, automation, and the Internet of Things (IoT)
        </h1>
      </div>

      <div className="grid grid-cols-3 gap-y-2 md:gap-y-20 gap-x-1 justify-items-center">
        {cardData.map((card, index) => (
          <Link to={`/${card.link}`} key={index}>
            <div className="relative max-w-[390px] rounded-md">
              <img
                src={card.image}
                alt={`Card ${index + 1}`}
                className="w-full h-auto object-cover rounded-md"
              />

              {/* Tag */}
              <div className="absolute md:top-4 md:left-2 top-1 left-1 w-[80px] md:w-[200px] h-[20px] md:h-[37px] flex items-center justify-center">
                <div className="absolute inset-0 bg-[#093816] opacity-90 mix-blend-multiply rounded-md"></div>
                <p className="relative text-white text-[6px] md:text-[14px] font-normal z-10">
                  Technology & Innovation
                </p>
              </div>

              {/* Text */}
              <div className="md:px-2 px-1 mt-2">
                <p className="text-[6px] md:text-[16px] text-black md:mt-5 mt-1">{card.date}</p>
                <p className="text-[7px] md:text-[20px] text-black font-bold leading-[1.1] md:mb-6 mb-1">
                  {card.title}
                </p>
                <p className="text-[6px] md:text-[16px] text-black font-normal leading-tight mb-5">
                  {card.description}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <div className="md:h-40 h-5"></div>
    </section>
  );
};

export default CardSection;
